<template>
  <div class="container login d-flex justify-content-center align-items-center">
    <div class="row page-content d-flex justify-content-center align-items-center">

      <div class="col-md-12 form min-height">

        <div class="form-content">

          <h2 class="form-title">SH DMH QA Sign in</h2>
          <b-form class="px-5">
            <b-form-group
              id="input-group-1"
              :label="getText.notLoggedIn.login.username"
              label-for="inputEmail"
            >
              <b-form-input
                type="email"
                id="inputEmail"
                v-model="user.email"
                :state="$v.user.email.$dirty ? !$v.user.email.$error : null"
                aria-describedby="user-name-error"
              ></b-form-input>
              <b-form-invalid-feedback id="user-name-error">
                {{ getText.notLoggedIn.login.usernameWarning }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              id="input-group-2"
              :label="getText.notLoggedIn.login.password"
              label-for="inputPass"
            >
              <div class="password-wrap">
                <b-form-input
                  :type="passwordFieldType"
                  id="inputPass"
                  v-model="user.password"
                  :state="
                    $v.user.password.$dirty ? !$v.user.password.$error : null
                  "
                  aria-describedby="password-error"
                  @keyup.enter.native="submitForm"
                ></b-form-input>
                <div class="eye" @click="switchVisibility">
                  <font-awesome-icon
                    v-if="passwordFieldType === 'password'"
                    icon="eye"
                  ></font-awesome-icon>
                  <font-awesome-icon
                    v-else
                    icon="eye-slash"
                  ></font-awesome-icon>
                </div>
              </div>
              <b-form-invalid-feedback id="password-error">
                {{ getText.notLoggedIn.login.passwordWarning }}
              </b-form-invalid-feedback>
            </b-form-group>

            <div
              col-sm-12
              class="
                submit-form
                text-center
                d-flex
                align-items-center
                justify-content-center
              "
            >
              <b-button
                type="button"
                @click="submitForm"
                class="py-3"
                variant="cta"
                >{{ getText.notLoggedIn.login.buttonText }}</b-button
              >
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config/constants";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  components: {  },
  name: "login",
  mixins: [validationMixin],
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      newUser: {
        org_code: "4wSZAoYA",
      },
      isSignUp: false,
      organisation: null,
      passwordFieldType: "password",
    };
  },
  validations: {
    user: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  methods: {
    switchForm() {
      this.isSignUp = !this.isSignUp;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    submitForm() {
      this.$v.user.$touch();
      if (this.$v.user.$anyError) {
        return;
      }
      this.signIn();
    },
    async signIn() {
      let payload = {
        username: this.user.email,
        password: this.user.password,
        encrypt_level: "high",
        platform: "web",
        lang: this.$store.state.lang,
      };
      let v3_ready = await this.$store.dispatch("signIn", {
        router: this.$router,
        payload,
      });
      if (v3_ready === false) {
        this.$emit("not-v3");
      }
    },
    async getOrgLocations() {
      let payload = { org_code: "4wSZAoYA", lang: this.$store.state.lang };
      try {
        let res = await axios.post(
          config.api_env + "/application/api-hc/get-client-signup-options",
          payload,
          config.options
        );
        this.organisation = res.data;
      } catch (e) {
        console.log(e);
      }
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
  },
  computed: {
    ...mapGetters(["hardcoded", "skin"]),
    getLogo() {
      if (this.hardcoded && this.hardcoded.logo) {
        return this.hardcoded.logo;
      } else return this.$store.getters.client.client_logo;
    },
  },
};
</script>
<style lang="less">
.page-content{
  max-width: 500px;
}
.cta-text{
  font-size: 1.8rem;
  font-weight: bold;
}
</style>
